import { render, staticRenderFns } from "./addItemOutList.vue?vue&type=template&id=480fb08c&scoped=true"
import script from "./addItemOutList.vue?vue&type=script&lang=js"
export * from "./addItemOutList.vue?vue&type=script&lang=js"
import style0 from "./addItemOutList.vue?vue&type=style&index=0&id=480fb08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fb08c",
  null
  
)

export default component.exports